import React from 'react';
import PostCard from '@components/molecules/post-card/post-card';
import { PostBlock } from '@interfaces/models/EditoPost';
import { useTranslation } from 'next-i18next';
import styles from '../post-list.module.scss';

interface PostItemProps {
  blockPost: PostBlock;
  sectionIdx?: string;
  index: number;
  totalItems: number;
  dataCy?: string;
}

const PostItem = ({ blockPost, sectionIdx, index, totalItems, dataCy }: PostItemProps) => {
  const { t: tA11y } = useTranslation('a11y');
  return (
    <li
      className={styles.listPost__list__item}
      data-cy={dataCy}
      aria-label={tA11y('A11Y.GENERIC_CURRENT_ITEM', { currentItem: index + 1, totalItems: totalItems })}
    >
      <div className={styles.listPost__list__item__post}>
        <PostCard
          {...blockPost}
          sectionIdx={sectionIdx}
          posX={String(index + 1)}
        />
      </div>
    </li>
  );
};

export default PostItem;
